/** @format */
export enum AddOnExperience {
	GRID = 'grid',
	SCROll = 'scroll',
	SHOP_THE_LOOK = 'shopTheLook'
}
